import React from 'react';
import ReactDOMServer from 'react-dom/server';
import AtlasV2DoubleDropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DoubleDropdownMetricColumnChart';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { AdvancedSearchParsedDatum } from 'src/serverProxy/useAdvancedSearchData';
import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import DefaultXAxisLabel from 'src/components/BeaconV2Components/TopEntityChartV2/DefaultXAxisLabel';
import { useStacklineTheme } from '@stackline/ui';

const AtlasV2PromotionsByDealTypeTopEntityChart = () => {
  const theme = useStacklineTheme();
  return (
    <AtlasV2DoubleDropdownMetricColumnChart
      useAdvancedSearchDataArgs={{
        requestId: `Promotions topEntity by Group`,
        requestBuilder: (builder, _, fields) => {
          if (['dataPointCount', 'retailPriceChangePercent'].includes(fields?.[0]?.name)) {
            builder
              .modifyAggregation((agg) =>
                agg
                  .addAggregationField('Promotion Sales', 'retailSales', 'sum', 'true')
                  .setSortByAggregationField('Promotion Sales', 'retailSales', 'sum', 'true')
              )
              .addConditionRangeFilter('retailSales', 0.1)
              .setSearchBy('parent');
          }

          builder.setPageSize(250);

          return builder;
        }
      }}
      showSingleGroupBy
      preProcessData={(data: AdvancedSearchParsedDatum[], field) => {
        switch (field.name) {
          case 'dataPointCount':
            return data.map((datum) => ({
              ...datum,
              values: {
                ...datum.values,
                dataPointCount_sum_value: datum?.values?.dataPointCount_sum_count ?? 0
              },
              comparisonValues: {
                ...datum.comparisonValues,
                dataPointCount_sum_value: datum?.comparisonValues?.dataPointCount_sum_count ?? 0
              }
            }));

          default:
            return data;
        }
      }}
      postProcessData={(data) => {
        if (data) {
          return data.map((row) => {
            const [group, value] = row;
            return [group, Math.abs(value)];
          });
        } else {
          return data;
        }
      }}
      xAxisFormatter={(xAxisCategory, id, tooltipId) => {
        const formattedDisplayName = _startCase(_toLower(xAxisCategory?.name?.split('_')));
        const formattedAxisCategory = { ...xAxisCategory, name: formattedDisplayName };

        const { currentValue, comparisonValue, metricType, currentGroupBy } = xAxisCategory;

        return ReactDOMServer.renderToStaticMarkup(
          <div id={id} style={{ position: 'relative' }}>
            <DefaultXAxisLabel
              xAxisCategory={formattedAxisCategory}
              id={xAxisCategory.id}
              tooltipId={tooltipId}
              wrapperStyle={{ width: '140px' }}
              theme={theme}
              currentValue={currentValue}
              comparisonValue={comparisonValue}
              metricType={metricType}
              currentGroupBy={currentGroupBy}
            />
          </div>
        );
      }}
      beaconChartWithLegendPropsBuilder={(props) => ({
        ...props,
        loadingComponent: <TopEntityChartV2Loading />
      })}
      fields={[
        { fieldName: 'dataPointCount', label: 'Promotion Count' },
        { fieldName: 'retailSales', label: 'Promotion Sales' },
        { fieldName: 'retailPriceChangePercent', label: 'Average Discount' }
      ]}
      groupByFields={[{ id: 'promoType', label: 'Deal Type', indexName: 'promotions' }]}
    />
  );
};

export default AtlasV2PromotionsByDealTypeTopEntityChart;
